import { render, staticRenderFns } from "./ViewAuditPeople.vue?vue&type=template&id=09d4e38b"
import script from "./ViewAuditPeople.vue?vue&type=script&lang=js"
export * from "./ViewAuditPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports